// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kSAa","newExpiryDate":"styles_newExpiryDate__WJgkj","footer":"styles_footer__1vdtm"};